module.exports = __webpack_public_path__ + "img/23.7c6b904f.png";